// Force redirect to /cart after a successful Add-to-Cart
// This fixes delayed ATC events in Ajax-based themes (e.g. Minimog)

(function () {
  function redirectToCart() {
    // Prevent redirect loops
    if (window.location.pathname === "/cart") return;
    window.location.href = "/cart";
  }

  // 1) Catch classic form submits to /cart/add
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!form || !form.action) return;

      try {
        const url = new URL(form.action, window.location.origin);
        if (url.pathname === "/cart/add") {
          // Let Shopify handle add-to-cart, then redirect
          setTimeout(redirectToCart, 50);
        }
      } catch (err) {}
    },
    true
  );

  // 2) Catch fetch-based Ajax add-to-cart
  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = function () {
      const args = arguments;
      const request = args[0];
      let url = "";

      try {
        url =
          typeof request === "string"
            ? request
            : request && request.url
            ? request.url
            : "";
      } catch (e) {}

      const isAddToCart = url.includes("/cart/add");

      return originalFetch.apply(this, args).then(function (response) {
        if (isAddToCart && response && response.ok) {
          setTimeout(redirectToCart, 0);
        }
        return response;
      });
    };
  }

  // 3) Catch XMLHttpRequest-based Ajax add-to-cart
  (function () {
    const open = XMLHttpRequest.prototype.open;
    const send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__isAddToCart =
        typeof url === "string" && url.indexOf("/cart/add") !== -1;
      return open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      const xhr = this;

      function onLoad() {
        if (
          xhr.__isAddToCart &&
          xhr.status >= 200 &&
          xhr.status < 300
        ) {
          setTimeout(redirectToCart, 0);
        }
      }

      xhr.addEventListener("load", onLoad);
      return send.apply(this, arguments);
    };
  })();
})();
